import '@/scss/pages/worksheets-single.scss'

import { checkQuery } from '@/js/helpers/check-query'
import initEmailWorksheetsPopup from '@/js/section/email-worksheets-popup'
import header from '@/js/layout/header'
import sliderWorksheetsPdf from '@/js/section/worksheets/shortcode-pdf'
import singleCTA from '@/js/section/blog/single-cta'
import fullForm from '@/js/section/home/full-form'
import { getTableOfContents } from '@/js/common/table-of-contents'
import anchor from '@/js/common/anchor'
import initStrip from '@/js/section/blog/strip'
import { bannerWide, bannerCta } from '@/js/common/banners'
import manageClassName from '@/js/helpers/manage-class'
import {
  setTrackDownloadCTAEvent,
  setTrackDownloadPDFEvent,
  setTrackWorksheetsImgEvent,
  setTrackExitPopupCloseEvent, setTrackStripCloseEvent
} from '@/js/common/button-track'
import { initClarity } from '@/js/helpers/clarity'
import config from '@/js/common/config.json'
import useFAQ from '@/js/section/pricing/faq'

document.addEventListener('DOMContentLoaded', function () {
  header()
  checkQuery()
  sliderWorksheetsPdf()
  singleCTA()
  fullForm()
  getTableOfContents()
  initEmailWorksheetsPopup('.download-topic', ['.aligncenter', '.gtm-worksheets-img'])
  anchor()
  initStrip()
  setTrackDownloadCTAEvent()
  setTrackDownloadPDFEvent()
  setTrackWorksheetsImgEvent()
  setTrackStripCloseEvent()
  setTrackExitPopupCloseEvent()
  bannerWide()
  bannerCta()
  useFAQ()
  manageClassName('iframe', 'iframe-formatting', 'add')
  initClarity('#main', config.worksheets)
})
